import axios from "axios";

export default function processWarrantyClaim(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/consumer/admin/api/v1/prife/claim/${parameters.id}/approval`, {
        status: parameters.status,
        replacement_method: parameters.replacementMethod,
        amount: parameters.amount,
        currency: parameters.currency,
        is_required_receive_faulty: parameters.isRequiredReceiveFaulty,
        reason: parameters.reason,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
